<template>
    <div class="page">
        <!-- 头部 -->
        <div class="header">
            <p class="title">Warranty Check</p>
            <!-- <div class="logo">
                <img :src="logo" alt="" />
            </div> -->
        </div>
        <!-- 广告图 -->
        <div class="AD-img">
            <img
                src="https://yf-files.oss-cn-hongkong.aliyuncs.com/banner/realme-banner.png"
                alt=""
            />
            <p>SERVICIOS DE SOPORTE Y GARANTÍA</p>
        </div>
        <!-- 查询框 -->
        <div class="searchBox">
            <div class="inputBox">
                <input
                    type="text"
                    class="searchInput"
                    placeholder="Por favor introduzca tu IMEI"
                    v-model="imei"
                />
            </div>
            <button
                class="searchBut"
                :style="{ background: $configs.m.site }"
                @click="search"
            >
                Verifica
            </button>
        </div>
        <div class="videoBox" v-show="videoUrl != ''">
            <video
                id="videoID"
                :src="videoUrl"
                width="100%"
                height="300"
                ref="video"
                controls
                muted
                autoplay
                style="background-color: #000000"
            >
                <source type="video/mp4" />
                您的浏览器不支持 HTML5 video 标签。
            </video>
        </div>

        <!-- 查询结果 -->
        <div class="result" v-if="status > 0">
            <p class="line">
                IMSI/SN :
                <span>{{ data.imei }}</span>
            </p>
            <p class="line">
                Nombre del producto:
                <span>{{ data.itemName }}</span>
            </p>
            <p class="line">
                Estado de garantía :
                <span v-if="status == 1">En garantía</span>
            </p>
            <p class="line">
                <span v-if="status == 2">Sin garantía</span>
            </p>
        </div>

        <div class="result" v-if="status == -1">
            <span>No tiene el IMEI en el sistema</span>
        </div>

        <!-- 服务 -->
        <!--
        <div class="piece">
            <h2 :style="{ color: $configs.m.site }">TEL:335-5555/7988-1919</h2>
            <p>facebook:Caniscarelaclinicadelcelular</p>
        </div> -->
        <div class="piece" style="padding-top: 20px">
            <p class="p-title">Panamá</p>
            <ul>
                <li>
                    <p class="title">Fast Service Centers</p>
                    <p class="text">Centro Comercial El Dorado Local 5;</p>
                    <p class="phoneNo" :style="{ color: $configs.p.site }">
                        Teléfono:388-3878
                    </p>

                    <p class="text">Plaza Terronal David Local 6A;</p>
                    <p class="phoneNo" :style="{ color: $configs.p.site }">
                        Teléfono:786-5810
                    </p>

                    <p class="title">Ave. Manuel Celestino González</p>
                    <p class="text">Diagonal a Coopeve, Santiago;</p>
                    <p class="phoneNo" :style="{ color: $configs.p.site }">
                        Teléfono:939-1168
                    </p>


                   
                        
                </li>
            </ul>
        </div>

         <div class="piece"  style="padding-top: 20px">
             <p class="p-title">Nicaragua</p>
             <ul>
                <li>
                   <p class="title">STG-Soporte Técnico Global</p>
                        <p class="text">Centro Comercial Camino de Oriente Edificio Bolerama módulos 1-4</p>
                        <p class="phoneNo" :style="{ color: $configs.p.site }">
                            Teléfono:505 2277 5431
                        </p>
                        <p class="text">Managua, Nicaragua</p>
            </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "mobileIndex",
    data() {
        return {
            imei: "",
            data: {},
            isExist: "",
            status: "",
            site: "",
            logo: "",
            headerBg: "",
            headerColor: "",
            videoUrl: "",
        };
    },
    mounted() {
        this.tenantGetFun();
        this.site = this.$configs.m.site;
        this.logo = this.$configs.m.logo;
    },
    methods: {
        ...mapActions(["getByImei", "tenantGet"]),
        // 视频信息
        async tenantGetFun() {
            const response = await this.tenantGet({});
            if (response.success) {
                console.log(response.data);
                let videoUrl = response.data.wartIndexVideoUrl;
                if (videoUrl != null) {
                    this.videoUrl = videoUrl;
                    var video = document.getElementById("videoID");
                    setTimeout(function () {
                        video.play();
                    }, 1000);
                }
            } else {
                this.$notify.error({
                    title: this.MyLanguage.common.errorText,
                    message: response.msg,
                });
            }
        },

        search() {
            this.getByImeiFun();
        },
        // 查询串码
        async getByImeiFun() {
            const response = await this.getByImei({
                imei: this.imei,
            });

            if (response.success) {
                if ((response.data != "") & (response.data != null)) {
                    this.data = response.data;
                    this.status = response.data.status;
                } else {
                    this.data = {};
                    this.status = -1;
                }
            } else {
                // this.$notify.error({
                //     title: "错误",
                //     message: response.msg,
                // });
                alert("错误:" + response.msg);
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.page
    background-color: #fff;
    font-size: 14px;
.header
    height: 50px;
    line-height: 50px;
    position: relative;
    .title
        text-align: center;
    .logo
        height: 23px;
        width: 80px;
        position: absolute;
        right: 10px;
        top: 6px;
        img
            height: 100%;
            width: 100%;
.AD-img
    width: 100vw;
    position: relative;
    img
        height: 100%;
        width: 100%;
        overflow: hidden;
    p
        color: #fff;
        font-size: 20px;
        position: absolute;
        left: 17%;
        top: 50%;
        transform: translate(0%, -50%);
.searchBox
    .inputBox
        border: 1px solid #ccc;
        height: 46px;
        width: 95vw;
        margin: 20px auto 0;
        input
            height: 46px;
            width: 100%;
            line-height: 46px;
            padding: 0 10px;
    .searchBut
        height: 30px;
        width: 80px;
        margin-left: 50%;
        margin-top: 20px;
        transform: translateX(-50%);
        border-radius: 3px;
        color: #fff;
.videoBox
    margin-top: 20px;
    width: 100%;
.result
    width: calc(95vw - 20px);
    margin: 20px auto 0;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
    padding: 10px;
    border-radius: 5px;
    .line
        margin: 10px 0;
.piece
    width: 95vw;
    margin: 20px auto 0;
    h2
        font-size: 14px;
    p
        margin: 10px 0;
    .p-title
        font-weight: bold;
        font-size: 20px;
    .title
        font-size: 18px;
        margin: 20px 0;
</style>



// WEBPACK FOOTER //
// src/views/mobile/starcell.vue